module.exports = __webpack_public_path__ + "static/media/moon.553da313.svg";